/**
 * Lightweight mobile/small-screen detection. Used to shrink the sorter's
 * memory footprint (concurrency=1, smaller max edge, fewer clusters on screen)
 * so iPhone Safari's ~1.5GB tab kill doesn't blank the page mid-upload.
 *
 * Two independent checks — either alone is a good signal but combining them
 * catches Chrome desktop with a narrow window too.
 */
export function isMobileUA() {
  if (typeof navigator === "undefined") return false;
  return /iPhone|iPad|iPod|Android|Mobile Safari/i.test(navigator.userAgent || "");
}

export function isMobileViewport() {
  if (typeof window === "undefined") return false;
  return window.matchMedia && window.matchMedia("(max-width: 900px)").matches;
}

export function isMobile() {
  return isMobileUA() || isMobileViewport();
}
